<div appDisableMouseWheel>
    <router-outlet></router-outlet>
</div>